import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect, CreateEffectMetadata } from '@ngrx/effects';
import { ToastrService } from 'ngx-toastr';
import { map } from 'rxjs/operators';
import { toastShow } from '../actions/toast.action';
import { ToastModel, ToastType } from '../../domain/models/toast.model';
import { Observable } from 'rxjs';

@Injectable()
export class ToastEffects {
    public toastShow$: (Observable<void> & CreateEffectMetadata) | undefined;
    private lastToastShowed: ToastModel | null = null;
    private lastToastShowedIn: Date | null = null;

    constructor(private actions$: Actions, private toastr: ToastrService) {
        this.createEffects()
    }

    private createEffects() {
        this.toastShow$ = createEffect(
            () =>
                this.actions$.pipe(
                    ofType(toastShow),
                    map(({ toastModel }) => {

                        if (this.lastToastShowed?.Mensagem != toastModel.Mensagem ||
                            (this.lastToastShowedIn != null && Math.abs(this.lastToastShowedIn.getTime() - (new Date()).getTime()) > 1500)
                        ) {

                            this.lastToastShowed = toastModel;
                            this.lastToastShowedIn = new Date();

                            switch (toastModel.Tipo) {
                                case ToastType.Success:
                                    this.toastr.success(toastModel.Mensagem, toastModel.Titulo);
                                    break;
                                case ToastType.Warning:
                                    this.toastr.warning(toastModel.Mensagem, toastModel.Titulo);
                                    break;
                                case ToastType.Error:
                                    this.toastr.error(toastModel.Mensagem, toastModel.Titulo);
                                    break;
                            }
                        }
                    })
                ),
            { dispatch: false }
        );
    }
}
